export { KTClipboard } from './clipboard';
export type { KTClipboardConfigInterface, KTClipboardInterface } from './types';
